import { type Addon, combineAPI } from 'Addons/combine';
import type { ReduxStoreType } from 'Core/store';

import colorSearch from './colorSearch';
import fitmentSearch from './fitmentSearch/index';
import search from './search/index';

import {
  colorSearchEnabled,
  fitmentSearchEnabled,
  searchEnabled,
} from '!!extract-features!Stores/soffseal/config';

const addons: Addon[] = [];
if (searchEnabled) {
  addons.push(search);
}
if (colorSearchEnabled) {
  addons.push(colorSearch);
}
if (fitmentSearchEnabled) {
  addons.push(fitmentSearch);
}

export const names = addons.map((a) => a.name);

const { initialize } = combineAPI(...addons);

const initializeAddons = (store: ReduxStoreType): void => initialize?.(store);

export { initializeAddons };
